import client from "./requestcsrf";

export default {
  API: {
    Objects: {
      get_token: () => {
        client.vue_login();

        return client.get(`${process.env.VUE_APP_CSRF_TOKEN_URL_PREFIX}csrf-token`).then(
          (response) => response,
          (err) => err
        );
      },
    },
  },
};
